import type { ReactNode } from "react";
import { IconSpace } from "./Icons";

type Props = {
  headline: string;
  body?: string;
  primaryLabel?: string;
  onPrimary?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  children?: ReactNode;
  icon?: ReactNode;
};

export function EmptyState({
  headline,
  body,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  children,
  icon,
}: Props) {
  return (
    <div className="empty-state">
      <div className="empty-state__glyph" aria-hidden>
        {icon ?? <IconSpace />}
      </div>
      <h3 className="empty-state__title">{headline}</h3>
      {body ? <p className="empty-state__body">{body}</p> : null}
      {(primaryLabel || secondaryLabel) && (
        <div className="row empty-state__actions">
          {primaryLabel && onPrimary ? (
            <button type="button" onClick={onPrimary}>
              {primaryLabel}
            </button>
          ) : null}
          {secondaryLabel && onSecondary ? (
            <button type="button" className="secondary" onClick={onSecondary}>
              {secondaryLabel}
            </button>
          ) : null}
        </div>
      )}
      {children}
    </div>
  );
}
